import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load department admins.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

const resolveCommunityId = (communityRef) => {
  if (typeof communityRef === 'string') {
    return communityRef.trim();
  }

  if (!communityRef || typeof communityRef !== 'object') {
    return '';
  }

  return String(
    communityRef.entityId ||
    communityRef.id ||
    communityRef._id ||
    ''
  ).trim();
};

export const fetchTeamAdmins = async (token) => {
  const response = await fetch(`${API_BASE}/api/communities/team-admins`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const fetchTeamAdminsForCurrentClub = async (token) => {
  const response = await fetch(`${API_BASE}/api/clubs/team-admins`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const fetchTeamAdminsForOrganization = async (organizationId) => {
  const response = await fetch(`${API_BASE}/api/communities/${organizationId}/team-admins`);

  return handleResponse(response);
};

export const fetchTeamAdminsForCommunity = async (communityId) => {
  const resolvedCommunityId = resolveCommunityId(communityId);
  const response = await fetch(
    `${API_BASE}/api/communities/${encodeURIComponent(resolvedCommunityId)}/team-admins`
  );

  return handleResponse(response);
};

export const fetchTeamAdminsForClub = async (clubId) => {
  const response = await fetch(`${API_BASE}/api/clubs/${clubId}/team-admins`);

  return handleResponse(response);
};

export const createTeamAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/team-admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create department admin.');
};

export const createTeamAdminForClub = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/team-admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create department admin.');
};

export const updateTeamAdmin = async (adminId, payload, token) => {
  const response = await fetch(`${API_BASE}/api/communities/team-admins/${adminId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to update department admin.');
};

export const updateTeamAdminForClub = async (adminId, payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/team-admins/${adminId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to update department admin.');
};

export const deleteTeamAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/communities/team-admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete department admin.');
};

export const deleteTeamAdminForClub = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/team-admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete department admin.');
};
